import {useFragment, useMutation} from 'admin/lib/apollo'
import {BASE_GROUP_FIELDS, CREATE_GROUP, UPDATE_GROUP} from 'admin/gql/Group.gql'
import useDestroyable from 'admin/hooks/useDestroyable'
import clearCache from 'admin/hooks/clearCache'

export default (organisationId, type, groupId) => {
  const variables = {organisationId, groupId}

  const {data: group = {}} = useFragment({
    from: `Group:${groupId}`,
    fragment: BASE_GROUP_FIELDS
  })

  const [create, {error: createError}] = useMutation(CREATE_GROUP, {
    variables,
    flash: 'Group created',
    update: (cache, {errors}) => !errors && clearCache({groups: {organisationId, type}}, {broadcast: true})(cache)
  })

  const [update, {error: updateError}] = useMutation(UPDATE_GROUP, {
    variables,
    flash: 'Group updated'
  })

  const {destroy, errors: destroyError} = useDestroyable('Group', groupId)

  return {
    group,
    errors: createError || updateError || destroyError || {},
    create,
    update,
    destroy
  }
}
